'use client';

import { getImageProxyUrl } from './proxy-url';

// S3 주소(src)를 받아서 Proxy를 거쳐 HTMLImageElement를 반환하는 함수
// createImageBitmap과 달리 픽셀 디코딩 없이 w/h를 읽을 수 있고, Konva에 직접 전달 가능
export const loadImage = (src: string): Promise<HTMLImageElement | null> => {
  const proxyUrl = getImageProxyUrl({ src });

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      // onload는 다운로드 완료만 보장하므로, decode()로 픽셀 디코딩까지 완료 후 resolve
      // 디코딩 실패 시에도 onload가 성공했으므로 이미지 자체는 유효 → reject하지 않고 resolve
      img.decode().then(
        () => resolve(img),
        () => resolve(img),
      );
    };
    img.onerror = () => {
      console.error(`이미지 로드 실패: ${src}`);
      resolve(null);
    };
    img.crossOrigin = 'anonymous';
    img.src = proxyUrl;
  });
};
